import { Link } from "react-router-dom";
import { Row, Col } from "antd";
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { motion } from "motion/react";
import logo from '../../assets/logo.png'
import Clogo from '../../assets/CollapsedLogo.png'


export default function Footer() {
  return (
    <footer className="bg-[#002020] text-brand-beige border-t border-brand-lightgold pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Row gutter={[48, 48]} className="mb-4 felx justify-center">
          {/* Brand & Intro */}
          <Col xs={24} md={12} lg={6}>
            <div className="flex flex-col gap-6">
              <Link to="/" className="flex items-center">
                <motion.img
                  whileHover={{ scale: 1.08 }}
                  transition={{ duration: 0.6 }}
                  src={logo}
                  alt=""
                  className="h-[60px] w-full object-cover"
                />
              </Link>
              <p className="text-sm leading-relaxed text-brand-gold">
                Every journey begins with hope,<br /> Every hope deserves the right begining.
              </p>
              <div className="flex gap-4">
                {[
                  { icon: Facebook, href: "https://facebook.com/yourpagename" },
                  { icon: Instagram, href: "https://www.instagram.com/vedanova.life?igsh=MTlwMnBkdzNvcmY4Mg==" },
                ].map(({ icon: Icon, href }, idx) => (
                  <a
                    key={idx}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full border border-brand-lightgold/30 flex items-center justify-center hover:bg-brand-lightgold/10 transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                ))}
              </div>
            </div>
          </Col>

          {/* Quick Links */}
          {/* Quick Links */}
          <Col className="" xs={12} md={12} lg={6}>
            <h4 className="text-[12px] font-bold uppercase tracking-widest text-brand-gold mb-6">Quick Links</h4>
            <ul className="flex flex-col gap-3 text-sm text-brand-beige/80 list-none p-0 m-0">
              <li><Link to="/" className="hover:text-brand-gold transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-brand-gold transition-colors">About</Link></li>
              <li><Link to="/treatments" className="hover:text-brand-gold transition-colors">Treatments</Link></li>
              {/* <li><Link to="/doctors" className="hover:text-brand-gold transition-colors">Expert Doctors</Link></li> */}
              <li><Link to="/reviews" className="hover:text-brand-gold transition-colors">Reviews</Link></li>
              <li><Link to="/appointment" className="hover:text-brand-gold transition-colors">Contact</Link></li>
            </ul>
          </Col>

          {/* Contact Details */}
          {/* Quick Links */}
          <Col className="" xs={12} md={12} lg={6}>
            <h4 className="text-[12px] font-bold uppercase tracking-widest text-brand-gold mb-6">Contact Us</h4>
            <Link to="/contact" className="block">
              <ul className="flex flex-col gap-4 text-sm text-brand-beige/80 list-none p-0 m-0">
                <li className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" />
                  <span>VedaNova AyurMed Pvt. Ltd. , Seawoods , Navi Mumbai 400706</span>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-brand-gold shrink-0" />
                  <span>+91 90281 56566 </span>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-brand-gold shrink-0" />
                  <span>care@vedanova.life</span>
                </li>
              </ul>
            </Link>
          </Col>
        </Row>

        <div className="flex items-center justify-center gap-3">
          <span className="h-px w-[45%] bg-white/25" />
          <img
            src={Clogo}
            alt={logo}
            className="relative w-20 h-20 object-contain "
          />        <span className="h-px w-[45%] bg-white/25" />
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[11px] font-bold uppercase tracking-widest text-brand-beige/60">
            © {new Date().getFullYear()} Veda Nova. All rights reserved.
          </p>
          <div className="flex gap-6 text-[11px] font-bold uppercase tracking-widest text-brand-beige/60">
            <Link
              to="/privacy_policy"
              className="hover:text-brand-gold transition-colors"
            >
              Privacy Policy
            </Link>

            <Link
              to="/terms"
              className="hover:text-brand-gold transition-colors"
            >
              Terms of Service
            </Link>

          </div>
        </div>
        <br />
        <div className="flex justify-start gap-3">
          <p className="text-[11px] font-bold uppercase tracking-widest text-brand-beige/60">Powered by ascensify</p>
          <div className="flex gap-4">
            {[
              { icon: Instagram, href: "https://www.instagram.com/ascensify.technologies?igsh=MTlwMnBkdzNvcmY4Mg==" },
            ].map(({ icon: Icon, href }, idx) => (
              <a
                key={idx}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-5 h-5 rounded-full border border-brand-lightgold/30 flex items-center justify-center hover:bg-brand-lightgold/10 transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
